import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { RefreshCw } from 'lucide-react';
export function AgitationSection() {
  return <Section className="bg-[#2c4a2c]/5 relative overflow-hidden" data-id="element-15">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#2c4a2c]/0 via-[#c45d3a]/30 to-[#2c4a2c]/0" data-id="element-16" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-17">
        <div data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-4" data-id="element-19">
            El coste no es solo el cansancio
          </h2>
          <p className="text-xl text-[#c45d3a] font-medium mb-4" data-id="element-20">
            El bajón de la tarde te roba energía… y también te roba decisiones.
          </p>

          <div className="space-y-4 text-[#5a5a5a]" data-id="element-21">
            <p className="leading-relaxed" data-id="element-22">
              <strong className="text-[#2c4a2c]" data-id="element-23">
                Te vuelves más reactiva:
              </strong>{' '}
              respondes peor, te cuesta concentrarte, sientes que "vas a
              rastras".
            </p>
            <p className="leading-relaxed" data-id="element-24">
              <strong className="text-[#2c4a2c]" data-id="element-25">
                Comes para sobrevivir, no para rendir:
              </strong>{' '}
              improvisas, picas, repites el ciclo.
            </p>
            <p className="leading-relaxed" data-id="element-26">
              <strong className="text-[#2c4a2c]" data-id="element-27">Lo peor:</strong> normalizas
              estar apagada y piensas que es "lo que toca" por la edad, el
              trabajo o el estrés.
            </p>
            <p className="leading-relaxed" data-id="element-28">
              Y cada tarde se convierte en una mini batalla: o café, o dulce, o
              ambas cosas.
            </p>
          </div>

          <div className="mt-6" data-id="element-29">
            <Button data-id="element-30">Quiero salir del ciclo</Button>
            <p className="mt-2 text-sm text-[#5a5a5a]" data-id="element-31">
              Sin extremos. Sin prohibiciones. Con estructura.
            </p>
          </div>
        </div>

        <div className="relative" data-id="element-32">
          <div className="bg-white p-6 rounded-full aspect-square flex flex-col items-center justify-center shadow-xl border-4 border-[#faf8f5] max-w-sm mx-auto relative z-10" data-id="element-33">
            <RefreshCw className="w-10 h-10 text-[#c45d3a] mb-3 animate-spin-slow" style={{
            animationDuration: '10s'
          }} data-id="element-34" />
            <h3 className="text-xl font-bold text-[#2c4a2c] mb-2" data-id="element-35">El Ciclo</h3>
            <div className="text-center space-y-1 text-sm font-medium text-[#5a5a5a]" data-id="element-36">
              <p data-id="element-37">Bajón de energía</p>
              <p data-id="element-38">↓</p>
              <p data-id="element-39">Antojo / Café</p>
              <p data-id="element-40">↓</p>
              <p data-id="element-41">Pico rápido</p>
              <p data-id="element-42">↓</p>
              <p data-id="element-43">Caída más fuerte</p>
            </div>
          </div>

          {/* Decorative circles */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-[#2c4a2c]/10 rounded-full" data-id="element-44" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] h-[150%] border border-[#2c4a2c]/5 rounded-full" data-id="element-45" />
        </div>
      </div>
    </Section>;
}